const CURRENCY_PARAM = 'currency';

const getParamFromLocation = (location: Location, name: string): string | undefined => {
  const fromSearch = new URLSearchParams(location.search).get(name);
  if (fromSearch) return fromSearch;

  const hash = location.hash;
  const queryStart = hash.indexOf('?');
  if (queryStart === -1) return undefined;

  return new URLSearchParams(hash.slice(queryStart + 1)).get(name) ?? undefined;
};

export function getUrlCurrency(
  location: Location = window.location,
  hostLocation?: Location | null,
): string | undefined {
  const hostCurrency = hostLocation ? getParamFromLocation(hostLocation, CURRENCY_PARAM) : undefined;
  const ownCurrency = getParamFromLocation(location, CURRENCY_PARAM);

  return hostCurrency ?? ownCurrency;
}
